import { Navigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';

/** The Approvals page (XBIT-4709) is the "Waiting for signers" tab of Operations since XBIT-4950; its old address, kept for bookmarks. */
export const VAULT_APPROVALS_PATH = '/vault/approvals';

const VaultApprovalsRedirect = () => (
  <Navigate to={`${paths.dashboard.vaultOperations.root}?tab=signers`} replace />
);

export default VaultApprovalsRedirect;
